import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box
} from '@mui/material';
import sendRequest from '../utils/sendRequest'
import QuizIcon from '@mui/icons-material/Quiz';
import { MenuButtonIcon, CancelButton, SubmitButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function RequestApprovalDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, isIcon=false, fetchPos=null }) {
  const [open, setOpen] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingRequest) {
      setOpen(false);
    }
  };

  const requestApproval = async () => {
    setLoadingRequest(true);
    try {
      let response = await sendRequest(`purchase-orders/request-approval?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      isIcon ? fetchPos() : fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingRequest(false);
    }
  }

  return (
    <Box>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Request Approval"}
        text={"Request Approval"}
        icon={QuizIcon}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingRequest}
      >
        <CustomDialogTitle
          header={"Request approval for Purchase"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Is the purchase order ready for approval?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingRequest}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingRequest}
            text={"Request Approval"}
            onClick={() => requestApproval()}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}